import { FormHookProvider } from '@/components/moleculas'
import Image from 'next/image'

// Styles
import styles from './styles.module.scss'
import logoBlack from '@/img/logoBlack.png'
import { useForm } from 'react-hook-form'
import { useCallback, useContext, useMemo, useState } from 'react'
import { RecoverPasswordContext } from '@/context/guest/Login/RecoverPassword'
import { InputTextCode } from '@/components/moleculas/InputText'
import Button from '@/components/moleculas/Button/Button'

export const RecoveryCode = () => {
  const { onSubmit, onClick } = useContext(RecoverPasswordContext)
  const [codeValues, setCodeValues] = useState(['', '', '', '', ''])
  const methods = useForm()

  const handleInputChange = useCallback(
    (e) => {
      const newValue = e.target.value
      if (newValue.length === 1 && e.target.nextElementSibling !== null) {
        e.target.nextElementSibling?.focus()
      } else if (newValue.length === 1 && e.target.nextElementSibling === null) {
        e.target.blur()
      }
    },
    []
  )

  const handleOnPaste = (e) => {
    const textPasted = e.clipboardData.getData('text/plain')
    setCodeValues(textPasted.split('').slice(0, 5))
    e.target.blur()
  }

  const handleInputOnKeyDown = useCallback((event) => {
    const keyCode = event.keyCode || event.which
    const input = event.target
    if (keyCode === 8) {
      input.value = ''
    } else if (
      (keyCode >= 48 && keyCode <= 57) || // Números (0-9)
      (keyCode === 86 || keyCode === 118) // Control + V
      // (keyCode >= 65 && keyCode <= 90) || // Letras mayúsculas (A-Z)
      // (keyCode >= 97 && keyCode <= 122) // Letras minúsculas (a-z)
    ) {
      if (input.value.length === 1) {
        event.preventDefault()
      }
    } else {
      event.preventDefault()
    }
  }, [])

  const inputTextCodeOne = useMemo(() => ({
    name: 'codeone',
    value: codeValues[0],
    rules: {
      required: true,
      minLength: {
        value: 1
      },
      maxLength: {
        value: 1
      },
      valueAsNumber: true,
      pattern: {
        value: /^(0|[1-9]\d*)(\.\d+)?$/
      }
    },
    onKeyDown: handleInputOnKeyDown,
    onChange: handleInputChange,
    onPaste: handleOnPaste
  }), [handleInputChange, handleInputOnKeyDown, codeValues])

  const inputTextCodeTwo = useMemo(() => ({
    name: 'codetwo',
    value: codeValues[1],
    rules: {
      required: true,
      minLength: {
        value: 1
      },
      maxLength: {
        value: 1
      },
      valueAsNumber: true,
      pattern: {
        value: /^(0|[1-9]\d*)(\.\d+)?$/
      }
    },
    onKeyDown: handleInputOnKeyDown,
    onChange: handleInputChange,
    onPaste: handleOnPaste
  }), [handleInputChange, handleInputOnKeyDown, codeValues])

  const inputTextCodeThree = useMemo(() => ({
    name: 'codethree',
    value: codeValues[2],
    rules: {
      required: true,
      minLength: {
        value: 1
      },
      maxLength: {
        value: 1
      },
      valueAsNumber: true,
      pattern: {
        value: /^(0|[1-9]\d*)(\.\d+)?$/
      }
    },
    onKeyDown: handleInputOnKeyDown,
    onChange: handleInputChange,
    onPaste: handleOnPaste
  }), [handleInputChange, handleInputOnKeyDown, codeValues])

  const inputTextCodeFour = useMemo(() => ({
    name: 'codefour',
    value: codeValues[3],
    rules: {
      required: true,
      minLength: {
        value: 1
      },
      maxLength: {
        value: 1
      },
      valueAsNumber: true,
      pattern: {
        value: /^(0|[1-9]\d*)(\.\d+)?$/
      }
    },
    onKeyDown: handleInputOnKeyDown,
    onChange: handleInputChange,
    onPaste: handleOnPaste
  }), [handleInputChange, handleInputOnKeyDown, codeValues])
  const inputTextCodeFive = useMemo(() => ({
    name: 'codefive',
    value: codeValues[4],
    rules: {
      required: true,
      minLength: {
        value: 1
      },
      maxLength: {
        value: 1
      },
      valueAsNumber: true,
      pattern: {
        value: /^(0|[1-9]\d*)(\.\d+)?$/
      }
    },
    onKeyDown: handleInputOnKeyDown,
    onChange: handleInputChange,
    onPaste: handleOnPaste
  }), [handleInputChange, handleInputOnKeyDown, codeValues])

  return (
    <div className={styles.section}>
      <div className={styles.section_container}>
        <div className={styles.section_header}>
          <Image
            width={500}
            height={500}
            alt='general-configuration'
            src={logoBlack}
            className={styles.image}
            loading='lazy'
          />
        </div>
        <FormHookProvider methods={methods} method='POST' onSubmit={onSubmit.handleVerifyCode}>
          <h2 className={styles.title}>Recuperar Contrase&ntilde;a</h2>
          <h3 className={styles.text}>Recupera tu contrase&ntilde;a</h3>
          <div className={styles['form-code']}>
            <InputTextCode {...inputTextCodeOne} />
            <InputTextCode {...inputTextCodeTwo} />
            <InputTextCode {...inputTextCodeThree} />
            <InputTextCode {...inputTextCodeFour} />
            <InputTextCode {...inputTextCodeFive} />
          </div>
          <div className={styles.form_button}>
            <div>
              <Button
                label='Volver'
                type='button'
                rounded
                className='btn-black btn-md'
                onClick={onClick.handleGoBack}
              />
            </div>
            <div>
              <Button
                label='Enviar código'
                type='submit'
                rounded
                className='btn-yellow btn-md'
              />
            </div>
          </div>
        </FormHookProvider>
      </div>
    </div>
  )
}
